import Comment from './comment'
import swal from 'sweetalert'
export default {
  name: 'detail',
  components: {Comment},
  props: [],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    faq () {
      return this.$store.getters['FAQ/getFAQSelect']
    },
    comments () {
      return this.$store.getters['FAQ/getCommentOfFAQSelect']
    },
    profile () {
      return this.$store.getters['Profile/getProfile']
    },
    group_faq () {
      return this.$store.getters['GroupFAQ/getListGroupFAQ']
    }
  },
  mounted () {
    this.$loading.start()
    // this.loading = true
    Promise.all([
      this.$store.dispatch('FAQ/showFAQ', {faq: {id: this.$route.params.faq_id}}),
      this.$store.dispatch('FAQ/getListCommentOfFAQ', {faq: {id: this.$route.params.faq_id}}),
      this.$store.dispatch('GroupFAQ/getListGroupFAQ', {page: 1, per_page: 'all'})
    ]).then(res => {
      this.$loading.complete()
      this.loading = false
    }).catch(errors => {
      // this.$loading.fail()
      this.loading = false
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.$loading.start()
    this.loading = true
    Promise.all([
      this.$store.dispatch('FAQ/showFAQ', {faq: {id: to.params.faq_id}}),
      this.$store.dispatch('FAQ/getListCommentOfFAQ', {faq: {id: to.params.faq_id}})
      // this.$store.dispatch('GroupFAQ/getListGroupFAQ', {page: 1, per_page: 'all'})
    ]).then(res => {
      this.$loading.complete()
      next()
      this.loading = false
    }).catch(errors => {
      // this.$loading.fail()
      this.loading = false
    })
  },
  methods: {
    destroy (comment) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$loading.start()
            this.$store.dispatch('FAQ/destroyFAQ', {
              faq: {id: this.$route.params.faq_id}
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.$loading.complete()
              this.$router.push('../list')
            }).catch(errors => {
              this.$loading.complete()
            })
          }
        })
    },
    changeStatus (faq) {
      this.$loading.start()
      if (parseInt(faq.is_resolve.code) === 0) {
        this.$store.dispatch('FAQ/closeFAQ', {faq}).then(res => {
          this.$loading.complete()
        }).catch(errors => {
          this.$loading.fail()
        })
      } else {
        this.$store.dispatch('FAQ/openFAQ', {faq}).then(res => {
          this.$loading.complete()
        }).catch(errors => {
          this.$loading.fail()
        })
      }
    },
    groupFaq (group) {
      this.$router.push('/forum/list?group_faq=' + group.id)
    },
    update (faq) {
      this.$router.push('/forum/' + faq.id + '/edit')
    }
    // pin (faq) {
    //   this.$loading.start()
    //   this.$store.dispatch('FAQ/updateFAQ', {faq}).then(res => {
    //     this.$loading.complete()
    //   }).catch(errors => {
    //     this.$loading.fail()
    //   })
    // }
  }
}



// WEBPACK FOOTER //
// ./src/views/faq/detail/detail.js